module.exports = __webpack_public_path__ + "img/uk-colorectal-cancer-male.04dafe38.png";